import { MapPin, MessageCircle, Clock, ExternalLink, ShieldCheck } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { AvailBadge, HoursList } from "@/components/site/ScheduleInfo";

export const LocationCard = ({ s }) => (
  <div className="rounded-3xl bg-white border border-nanina-line p-5 sm:p-6" data-testid="location-card">
    <div className="flex gap-3">
      <span className="grid place-items-center h-11 w-11 shrink-0 rounded-xl bg-nanina-skysoft text-nanina-green"><MapPin className="h-5 w-5" /></span>
      <div>
        <p className="text-sm font-bold text-nanina-green">Lokasi Nanina Care / PMB Nina</p>
        <p className="mt-1 text-sm text-nanina-muted leading-relaxed" data-testid="contact-address">{s.address}</p>
      </div>
    </div>
    {s.maps_url && (
      <a href={s.maps_url} target="_blank" rel="noopener noreferrer" className="mt-4 inline-flex items-center gap-2 rounded-full border border-[#CCE0D9] bg-white text-nanina-green text-sm font-semibold px-5 py-2.5 hover:bg-[#F2FAF6] transition-colors" data-testid="google-maps-button">
        Lihat Lokasi di Google Maps <ExternalLink className="h-4 w-4" />
      </a>
    )}
    {s.maps_embed_url && (
      <iframe title="Peta lokasi Nanina Care" src={s.maps_embed_url} className="mt-4 w-full h-56 rounded-2xl border-0" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-testid="google-maps-embed" />
    )}
  </div>
);

const HoursCard = ({ s }) => (
  <div id="jam-operasional" className="rounded-3xl bg-white border border-nanina-line p-5 sm:p-6" data-testid="operating-hours-card">
    <div className="flex items-center justify-between gap-2">
      <p className="flex items-center gap-2 text-sm font-bold text-nanina-green"><Clock className="h-4 w-4" /> Jam operasional</p>
      <AvailBadge status={s.service_status} testId="service-status-badge" />
    </div>
    {s.service_status_note && <p className="mt-2 text-xs text-nanina-muted" data-testid="service-status-note">{s.service_status_note}</p>}
    <div className="mt-3"><HoursList hours={s.operating_hours} testId="operating-hours" /></div>
  </div>
);

export const ContactSection = () => {
  const { site, openInquiry } = useSite();
  const s = site.settings;
  return (
    <section id="kontak" className="pb-14 sm:pb-20" data-testid="contact-section">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-nanina-fresh">Kontak</p>
        <h2 className="mt-1 text-2xl sm:text-3xl font-extrabold tracking-tight text-nanina-green">Hubungi Nanina Care</h2>
        <div className="mt-5 grid md:grid-cols-2 gap-3 sm:gap-4">
          <div className="rounded-3xl bg-nanina-green text-white p-5 sm:p-6 flex flex-col justify-between gap-4">
            <div>
              <p className="flex items-center gap-2 text-sm font-bold"><MessageCircle className="h-4 w-4" /> WhatsApp Admin</p>
              <p className="mt-2 text-2xl font-extrabold tracking-tight" data-testid="contact-whatsapp-number">{s.whatsapp_display}</p>
              <p className="mt-1 text-xs text-[#DCF0E9]">Isi formulir singkat agar admin dapat membantu lebih cepat. Pertanyaan bukan konfirmasi booking.</p>
            </div>
            <button onClick={() => openInquiry()} className="self-start rounded-full bg-white text-nanina-green text-sm font-semibold px-5 py-3 hover:-translate-y-0.5 transition-transform" data-testid="contact-whatsapp-button">
              Isi formulir & buka WhatsApp
            </button>
          </div>
          <LocationCard s={s} />
          <HoursCard s={s} />
          <div className="rounded-3xl bg-[#EEF7E9] p-5 sm:p-6 flex gap-3" data-testid="privacy-card">
            <ShieldCheck className="h-5 w-5 shrink-0 text-nanina-green" />
            <div>
              <p className="text-sm font-bold text-nanina-green">Privasi Anda</p>
              <p className="mt-1 text-xs text-nanina-muted leading-relaxed">{s.privacy_note}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
